// extracted by mini-css-extract-plugin
module.exports = {"root":"CompleteLink_root__3XKJf","rootSuccess":"CompleteLink_rootSuccess__tw6xW","rootFailure":"CompleteLink_rootFailure__2HvRm","isDisabled":"CompleteLink_isDisabled__2r8L7"};